import { useHomeScreenConfig } from '@tovala/browser-apis-cdn'
import {
  useActiveIncentives,
  UserIncentive,
  UserV1,
} from '@tovala/browser-apis-combinedapi'
import { useVariantByScreenSize } from 'hooks/variantByScreenSize'
import {
  getAutoApplyIncentiveCardContent,
  getIncentivesToDisplay,
} from 'utils/incentives'
import { useState } from 'react'
import PromosCreditsModal from '../PromosCreditsModal'

const MyOrdersIncentive = ({ user }: { user: UserV1 }) => {
  const [modalOpen, setModalOpen] = useState(false)

  const { data: activeIncentives = [] } = useActiveIncentives({
    userID: user.id,
  })
  const numberOfIncentivesToDisplay = useVariantByScreenSize<number>(2, {
    md: 1,
  })

  const featuredIncentives = getFeaturedIncentives({
    activeIncentives,
    isFreeDessertCustomer: user.isFreeDessertCustomer,
    quantity: numberOfIncentivesToDisplay,
  })

  const { data: homeScreenConfig } = useHomeScreenConfig({
    enabled: featuredIncentives.length > 0,
  })
  const { incentiveBanner } = homeScreenConfig || {}

  if (featuredIncentives.length === 0) {
    return null
  }

  return (
    <>
      {modalOpen && (
        <PromosCreditsModal
          onCloseModal={() => setModalOpen(false)}
          user={user}
        />
      )}
      <div className="grid grid-cols-2 gap-4 md:grid-cols-1">
        {featuredIncentives.map((incentive) => {
          const content = getAutoApplyIncentiveCardContent(incentive)
          return (
            <button key={incentive.offerID} onClick={() => setModalOpen(true)}>
              <IncentiveCard
                backgroundColor={incentiveBanner?.backgroundColor ?? '#E3EAEE'}
                imageURL={incentiveBanner?.accessoryImage ?? ''}
                subtitle={content.subtitle}
                subtitleColor={incentiveBanner?.subtitleColor ?? '#55554F'}
                title={content.title}
                titleColor={incentiveBanner?.textColor ?? '#39392D'}
              />
            </button>
          )
        })}
      </div>
    </>
  )
}

export default MyOrdersIncentive

const IncentiveCard = ({
  backgroundColor,
  imageURL,
  subtitle,
  subtitleColor,
  title,
  titleColor,
}: {
  backgroundColor: string
  imageURL: string
  subtitle: string
  subtitleColor: string
  title: string
  titleColor: string
}) => {
  return (
    <div
      className="flex items-center space-x-3 rounded-xl p-4 text-left"
      style={{ backgroundColor }}
    >
      <div className="w-14">
        <img alt="" src={imageURL} />
      </div>
      <div>
        <h2
          className="text-k/20_110 font-semibold"
          style={{ color: titleColor }}
        >
          {title}
        </h2>
        <p className="text-k/14_120" style={{ color: subtitleColor }}>
          {subtitle}
        </p>
      </div>
    </div>
  )
}

// Get up to 2 incentives (2 on desktop, 1 on mobile)
function getFeaturedIncentives({
  activeIncentives,
  isFreeDessertCustomer,
  quantity,
}: {
  activeIncentives: UserIncentive[]
  isFreeDessertCustomer: boolean
  quantity: number
}) {
  return getIncentivesToDisplay({
    activeIncentives,
    isFreeDessertCustomer,
  }).slice(0, quantity)
}
